import React from "react";
import PropTypes from 'prop-types';

import List from "@material-ui/core/List/List";
import Divider from "@material-ui/core/Divider/Divider";

import {findRoute} from "../Drawer/router";

import {
    Drawer,
    DrawerItem,
    CaptionItem,
    BackItem,
} from '../Drawer';

class Navigation extends React.Component {

    static propTypes = {
        items: PropTypes.array.isRequired,
    };

    state = this.tryRestoreState();

    tryRestoreState() {
        let history = [null];

        // Build route history trace.
        findRoute(this.props.items,
            route => history.splice(1, 0, route)
        );

        // Restore state or return default.
        const context = history.pop();
        return {
            context,
            history,
            items: context ? context.items : this.props.items,
        };
    }

    handleSwitchContext(newContext) {
        let {context, history, items} = this.state;

        // Manage history.
        if (newContext) {
            // Push to history.
            history.push(context);
        } else {
            // Navigate back.
            newContext = history.pop();
        }

        // Set new items by context.
        if (newContext) {
            // Add items from context.
            items = newContext.items;
        } else {
            // Reset items to default.
            items = this.props.items;
        }

        this.setState({
            context: newContext,
            history,
            items,
        });
    }

    renderCaption(context) {
        return (
            <React.Fragment>
                <BackItem
                    onClick={this.handleSwitchContext.bind(this, null)}
                />

                <CaptionItem
                    icon={context.icon}
                    text={context.text}
                />
            </React.Fragment>
        );
    }

    renderItem(item) {
        if (item.divider) {
            // Render a divider.
            return (
                <Divider key={item.text}/>
            );
        } else if (item.items) {
            // Render a node item.
            return (
                <DrawerItem
                    onClick={this.handleSwitchContext.bind(this, item)}
                    accessoryIcon="chevron_right"
                    key={item.text}
                    text={item.text}
                    icon={item.icon}
                />
            );
        } else {
            // Render a default item.
            return (
                <DrawerItem
                    component="a"
                    key={item.text}
                    text={item.text}
                    icon={item.icon}
                    href={item.href}
                    exact={item.exact}
                    strict
                />
            );
        }
    }

    render() {
        const {context, items} = this.state;

        return (
            <Drawer {...this.props}>
                {context && (
                    this.renderCaption(context)
                )}

                <List component="nav">
                    {items.map(
                        item => this.renderItem(item)
                    )}
                </List>
            </Drawer>
        );
    };
}

export default Navigation;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Navigation/Navigation.jsx